import { unzipSync, zipSync, strFromU8, strToU8 } from 'fflate';

const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const DOCUMENT_PART = 'word/document.xml';

export class DocxPackage {
  private readonly parts: Record<string, Uint8Array>;

  private constructor(parts: Record<string, Uint8Array>) {
    this.parts = parts;
  }

  static async open(source: Blob | ArrayBuffer | Uint8Array): Promise<DocxPackage> {
    const bytes = await toBytes(source);

    return new DocxPackage(unzipSync(bytes));
  }

  names(): readonly string[] {
    return Object.keys(this.parts);
  }

  text(name: string): string | undefined {
    const raw = this.parts[name];
    if (!raw) {
      return undefined;
    }

    return strFromU8(raw);
  }

  bytes(name: string): Uint8Array | undefined {
    return this.parts[name];
  }

  toBlob(overrides: Readonly<Record<string, string>> = {}): Blob {
    const out: Record<string, Uint8Array> = { ...this.parts };

    for (const [name, xml] of Object.entries(overrides)) {
      out[name] = strToU8(xml);
    }

    return new Blob([zipSync(out) as BlobPart], { type: DOCX_MIME });
  }
}

async function toBytes(source: Blob | ArrayBuffer | Uint8Array): Promise<Uint8Array> {
  if (source instanceof Uint8Array) {
    return source;
  }

  if (source instanceof ArrayBuffer) {
    return new Uint8Array(source);
  }

  return new Uint8Array(await source.arrayBuffer());
}
